import { 
  collection, 
  addDoc, 
  getDocs, 
  query, 
  where, 
  orderBy, 
  serverTimestamp,
  Timestamp,
  increment,
  runTransaction,
  getDoc,
  doc
} from "firebase/firestore";
import { db } from "../lib/firebase";

const docToOrder = (id, data) => ({
  id,
  ...data,
  createdAt: data.createdAt instanceof Timestamp ? data.createdAt.toDate().toISOString() : data.createdAt,
});

const reduceStock = async (items) => {
  try {
    await runTransaction(db, async (transaction) => {
      for (const item of items) {
        if (item.variantId) {
          const variantRef = doc(db, "variants", item.variantId);
          transaction.update(variantRef, {
            stock: increment(-item.quantity)
          });
        } else {
          const productRef = doc(db, "products", item.id);
          transaction.update(productRef, {
            stock: increment(-item.quantity)
          });
        }
      }
    });
  } catch (error) {
    console.error("Error reducing stock:", error);
    // Continue even if stock reduction fails (debatable, but usually safer for customer flow)
  }
};

export const createOrder = async (orderData) => {
  // 1. Reduce Stock
  await reduceStock(orderData.items);

  // 2. Create Order
  const docRef = await addDoc(collection(db, "orders"), {
    ...orderData,
    status: "PENDING",
    createdAt: serverTimestamp(),
  });
  return docRef.id;
};

export const getUserOrders = async (userId) => {
  const q = query(
    collection(db, "orders"), 
    where("userId", "==", userId), 
    orderBy("createdAt", "desc")
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => docToOrder(d.id, d.data()));
};

export const getOrderById = async (orderId) => {
  const docRef = doc(db, "orders", orderId);
  const snap = await getDoc(docRef);
  if (snap.exists()) {
    return docToOrder(snap.id, snap.data());
  }
  throw new Error("Order not found");
};

export const updateOrderPayment = async (orderId, paymentData) => {
  const { updateDoc } = await import("firebase/firestore");
  const docRef = doc(db, "orders", orderId);
  await updateDoc(docRef, {
    ...paymentData,
    updatedAt: serverTimestamp(),
  });
};

export const getDeliveryByOrderId = async (orderId) => {
  const q = query(collection(db, "deliveries"), where("orderId", "==", orderId));
  const snap = await getDocs(q);
  if (snap.empty) return null;
  const data = snap.docs[0].data();
  return {
    id: snap.docs[0].id,
    ...data,
    estimatedDate: data.estimatedDate instanceof Timestamp ? data.estimatedDate.toDate().toISOString() : data.estimatedDate,
    updatedAt: data.updatedAt instanceof Timestamp ? data.updatedAt.toDate().toISOString() : data.updatedAt,
  };
};
